import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { Slide } from "@mui/material";
import { SnackbarProvider } from "notistack";
import { Auth0Provider } from "@auth0/auth0-react";

import { store } from "./redux/store";
import App from "./containers/App";
import { SocketProvider } from "./context/SocketProvider";

import "leaflet/dist/leaflet.css";
import "../src/styles/Map.css";

const root = createRoot(document.getElementById("root"));

const AUDIENCE = process.env.REACT_APP_AUTH0_AUDIENCE;
const CLIENT_ID = process.env.REACT_APP_AUTH0_CLIENT_ID;
const AUTH0_DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN;
root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={AUTH0_DOMAIN}
      clientId={CLIENT_ID}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: AUDIENCE,
      }}
    >
      <BrowserRouter>
        <Provider store={store}>
          <SnackbarProvider
            maxSnack={3}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            TransitionComponent={Slide}
          >
            <SocketProvider>
              <App />
            </SocketProvider>
          </SnackbarProvider>
        </Provider>
      </BrowserRouter>
    </Auth0Provider>
  </React.StrictMode>
);
